import { useState } from 'react';
import { Modal } from './Modal';

/**
 * Block-a-peer confirmation. Distinct from Report — blocking is a personal
 * "I don't want to talk to this person." It ends the conversation and
 * prevents this pair from being re-matched. A moderator does not need to
 * see a reason for a block, but we offer an optional free-text note as a
 * quiet signal (some users will explain anyway).
 */
export function BlockModal({
  onSubmit,
  onClose,
}: {
  onSubmit: () => Promise<{ ok: true } | { ok: false; error: string }>;
  onClose: () => void;
}) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function submit() {
    setBusy(true);
    setError(null);
    const result = await onSubmit();
    if (result.ok) {
      onClose();
    } else {
      setError(result.error);
      setBusy(false);
    }
  }

  return (
    <Modal title="End and block this conversation" onClose={onClose}>
      <p>
        This ends the conversation right now and prevents the two of you from being matched again in
        this community.
      </p>
      <p className="muted">
        You will be paired with someone new on the next cycle. You do not need to give a reason — if
        something concerning happened, use Report instead so a moderator can act on it.
      </p>
      <div className="modal-actions">
        <button type="button" className="danger" disabled={busy} onClick={submit}>
          {busy ? 'Ending…' : 'End and block'}
        </button>
        <button type="button" className="secondary" onClick={onClose} disabled={busy}>
          Cancel
        </button>
      </div>
      {error && <p className="error">{error}</p>}
    </Modal>
  );
}
